import * as types from "../types/company";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveCompanyDetails,
  retrieveCompanyImage,
  updateCompanyImage,
  deleteCompanyImage,
  retrieveCompanyTeam,
  retrieveCompanyReceipts,
  retrieveCompanySubscription,
  deleteCompanySubscription,
  sendCompanyInvitation,
  deleteCompany,
  removeMember,
  changeMember,
  updateCompanyDetails,
  retrieveCompanyPaymentMethods,
  deletePaymentMethod,
  addPaymentMethod,
  updatePaymentMethod,
  updateLicenseQuantity,
  retrieveCompanyChannels,
} from "../../networking/company/networking";

function* fetchCompanyDetails(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveCompanyDetails, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_COMPANY_DETAILS,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente kundedetaljer.");
      }
    } else {
      throw new Error("Kunne ikke hente bedriftsinformasjon.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_DETAILS, message: e });
  }
}

function* performUpdateImage(action) {
  try {
    if (action.details) {
      const status = yield call(updateCompanyImage, action.details);
      if (status.error === null) {
        yield put({ type: types.GRANT_UPDATE_COMPANY_IMAGE });
      } else {
        throw new Error("Kunne ikke oppdatere bilde.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere bilde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_COMPANY_IMAGE, message: e });
  }
}

function* performDeleteImage(action) {
  try {
    if (action.details) {
      const response = yield call(deleteCompanyImage, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_COMPANY_IMAGE });
      } else {
        throw new Error("Kunne ikke slette bilde");
      }
    } else {
      throw new Error("Kunne ikke slette bilde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_COMPANY_IMAGE, message: e });
  }
}

function* performRetrieveImage(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveCompanyImage, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_COMPANY_IMAGE, image: response.payload });
      } else {
        throw new Error("Kunne ikke hente bilde.");
      }
    } else {
      throw new Error("Kunne ikke hente bilde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_IMAGE, message: e });
  }
}

function* performRetrieveTeam(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveCompanyTeam, action.payload);
      if (response.error === null) {
        yield put({ type: types.SET_COMPANY_TEAM, details: response.payload });
      } else {
        throw new Error("Kunne ikke hente team.");
      }
    } else {
      throw new Error("Kunne ikke hente team.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_TEAM, message: e });
  }
}

function* performRetrieveReceipts(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveCompanyReceipts, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_COMPANY_RECEIPTS,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente betalinger.");
      }
    } else {
      throw new Error("Kunne ikke hente betalinger");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_RECEIPTS, message: e.error });
  }
}

function* performRetrieveSubscription(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveCompanySubscription, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_COMPANY_SUBSCRIPTION,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente abonnement.");
      }
    } else {
      throw new Error("Kunne ikke hente abonnement.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_SUBSCRIPTION, message: e });
  }
}

function* performSubscriptionDeletion(action) {
  try {
    if (action.payload) {
      const response = yield call(deleteCompanySubscription, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_SUBSCRIPTION_DELETION });
      } else {
        throw new Error("Kunne ikke avslutte abonnement.");
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({
      type: types.REVOKE_SUBSCRIPTION_DELETION,
      message: errMessage,
    });
  }
}

function* performSendInvitation(action) {
  try {
    if (action.payload) {
      const response = yield call(sendCompanyInvitation, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_SEND_INVITATION });
        yield put({
          type: types.CHANGE_COMPANY_MODALS,
          modal: { addMember: false },
        });
      } else {
        throw new Error("Kunne ikke sende invitasjon.");
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({ type: types.REVOKE_SEND_INVITATION, message: errMessage });
    yield put({
      type: types.CHANGE_COMPANY_MODALS,
      modal: { addMember: false },
    });
  }
}

function* performDeleteCompany(action) {
  try {
    if (action.payload) {
      const response = yield call(deleteCompany, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_COMPANY });
      } else {
        throw new Error("Kunne ikke slette foretak.");
      }
    } else {
      throw new Error("Kunne ikke slette foretak.");
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_DELETE_COMPANY, message: error });
  }
}

function* performDeleteMember(action) {
  try {
    if (action.payload) {
      const response = yield call(removeMember, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_MEMBER });
        yield put({
          type: types.CHANGE_COMPANY_MODALS,
          modal: { removeMember: false },
        });
      } else {
        throw new Error("Kunne ikke slette bruker.");
      }
    } else {
      throw new Error("Kunne ikke slette bruker.");
    }
  } catch (e) {
    yield put({
      type: types.CHANGE_COMPANY_MODALS,
      modal: { removeMember: false },
    });
    yield put({ type: types.REVOKE_DELETE_MEMBER, message: e });
  }
}

function* performChangeMember(action) {
  try {
    if (action.payload) {
      const response = yield call(changeMember, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_CHANGE_MEMBER });
        yield put({
          type: types.CHANGE_COMPANY_MODALS,
          modal: { changeRole: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere bruker.");
      }
    } else {
      throw new Error("Kan ikke oppdatere bruker.");
    }
  } catch (e) {
    yield put({
      type: types.CHANGE_COMPANY_MODALS,
      modal: { changeRole: false },
    });
    yield put({ type: types.REVOKE_CHANGE_MEMBER, message: e });
  }
}

function* performUpdateCompanyDetails(action) {
  try {
    if (action.payload) {
      const status = yield call(updateCompanyDetails, action.payload);
      if (status.error === null) {
        yield put({
          type: types.GRANT_UPDATE_COMPANY_DETAILS,
          details: status.payload,
        });
      } else {
        throw new Error("Kunne ikke oppdatere detaljer.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere detaljer.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_COMPANY_DETAILS, message: e });
  }
}

function* performRetrievePaymentMethods(action) {
  try {
    if (action.payload) {
      const response = yield call(
        retrieveCompanyPaymentMethods,
        action.payload
      );
      if (response.error === null) {
        yield put({
          type: types.SET_COMPANY_PAYMENT_METHODS,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente betalingsmetoder.");
      }
    } else {
      throw new Error("Kunne ikke hente betalingsmetoder.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_PAYMENT_METHODS, message: e });
  }
}

function* performPaymentMethodDeletion(action) {
  try {
    if (action.payload) {
      const response = yield call(deletePaymentMethod, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_PAYMENT_METHOD });
        yield put({
          type: types.CHANGE_COMPANY_MODALS,
          modal: { removePaymentMethod: false },
        });
      } else {
        throw new Error("Kunne ikke slette betalingsmetode.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_PAYMENT_METHOD, message: e });
    yield put({
      type: types.CHANGE_COMPANY_MODALS,
      modal: { removePaymentMethod: false },
    });
  }
}

function* performAddPaymentMethod(action) {
  try {
    if (action.payload) {
      const response = yield call(addPaymentMethod, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_PAYMENT_METHOD });
        yield put({
          type: types.CHANGE_COMPANY_MODALS,
          modal: { addPaymentMethod: false },
        });
      } else {
        throw new Error(response.error);
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({ type: types.REVOKE_ADD_PAYMENT_METHOD, message: errMessage });
  }
}

function* performUpdatePaymentMethod(action) {
  try {
    if (action.payload) {
      const response = yield call(updatePaymentMethod, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_PAYMENT_METHOD });
        yield put({
          type: types.CHANGE_COMPANY_MODALS,
          modal: { updatePaymentMethod: false },
        });
      } else {
        throw new Error(response.error);
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({
      type: types.REVOKE_UPDATE_PAYMENT_METHOD,
      message: errMessage,
    });
  }
}

function* performUpdateLicenseQuantity(action) {
  try {
    if (action.payload) {
      const response = yield call(updateLicenseQuantity, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_LICENSE_QUANTITY });
        yield put({
          type: types.CHANGE_COMPANY_MODALS,
          modal: { changeMainSubscription: false },
        });
      } else {
        throw new Error(response.error);
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({
      type: types.REVOKE_UPDATE_LICENSE_QUANTITY,
      message: errMessage,
    });
  }
}

function* performRetrieveChannels(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveCompanyChannels, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_COMPANY_CHANNELS,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente team.");
      }
    } else {
      throw new Error("Kunne ikke hente team.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_CHANNELS, message: e });
  }
}

function* companySaga() {
  yield all([
    takeEvery(types.REQUEST_COMPANY_DETAILS, fetchCompanyDetails),
    takeEvery(types.REQUEST_UPDATE_COMPANY_IMAGE, performUpdateImage),
    takeEvery(types.REQUEST_DELETE_COMPANY_IMAGE, performDeleteImage),
    takeEvery(types.REQUEST_COMPANY_IMAGE, performRetrieveImage),
    takeEvery(types.REQUEST_COMPANY_TEAM, performRetrieveTeam),
    takeEvery(types.REQUEST_COMPANY_RECEIPTS, performRetrieveReceipts),
    takeEvery(types.REQUEST_COMPANY_SUBSCRIPTION, performRetrieveSubscription),
    takeEvery(types.REQUEST_SUBSCRIPTION_DELETION, performSubscriptionDeletion),
    takeEvery(types.REQUEST_SEND_INVITATION, performSendInvitation),
    takeEvery(types.REQUEST_DELETE_COMPANY, performDeleteCompany),
    takeEvery(types.REQUEST_DELETE_MEMBER, performDeleteMember),
    takeEvery(types.REQUEST_CHANGE_MEMBER, performChangeMember),
    takeEvery(
      types.REQUEST_UPDATE_COMPANY_DETAILS,
      performUpdateCompanyDetails
    ),
    takeEvery(
      types.REQUEST_COMPANY_PAYMENT_METHODS,
      performRetrievePaymentMethods
    ),
    takeEvery(
      types.REQUEST_DELETE_PAYMENT_METHOD,
      performPaymentMethodDeletion
    ),
    takeEvery(types.REQUEST_ADD_PAYMENT_METHOD, performAddPaymentMethod),
    takeEvery(types.REQUEST_UPDATE_PAYMENT_METHOD, performUpdatePaymentMethod),
    takeEvery(
      types.REQUEST_UPDATE_LICENSE_QUANTITY,
      performUpdateLicenseQuantity
    ),
    takeEvery(types.REQUEST_COMPANY_CHANNELS, performRetrieveChannels),
  ]);
}

export default companySaga;
